// 音频对外事件（与音频元素一致）
export enum eAudioCoreEvts {
  durationchange = 'durationchange',
  timeupdate = 'timeupdate',
  canplay = 'canplay',
  play = 'play',
  pause = 'pause',
  ended = 'ended',
  muted = 'muted',
  volumechange = 'volumechange',
  ratechange = 'ratechange',
  error = 'error',
}
